import { LogicalErrorDocumentType } from 'app/shared/constants/logical-error-document-type';
import { Params } from '@angular/router';
import { BoardOptionalParams } from 'app/dashboard-shared/enums/board-optional-params.enum';

export type SchoolAdminBaseParams = {
  statsType: string,
  year: string, // could be number but leaving as string for now
};

export type SchoolAdminParamsExtendedScopeAndCourse = SchoolAdminBaseParams & {
  scope: string,
  courseId: string,
};

export type CategoryExtension = {
  categoryGroupId: string,
};

export type LogicalErrorExtension = {
  logicalErrorId: string,
};

export const SCHOOL_ADMIN_ROUTE = {
  name: 'schooladmin',
  route(): string[] {
    return ['/', this.name];
  },
  DEFAULT: '',
  CLASS: {
    name: 'class/:classId',
    route(classId: string): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'class', classId];
    },
    GAMESHOW_REPORT: {
      name: 'gameshowreport/:gameshowRunId/:plcId',
      route(classId: string, gameshowRunId: string, plcId: string): string[] {
        return [...SCHOOL_ADMIN_ROUTE.CLASS.route(classId), 'gameshowreport', gameshowRunId, plcId];
      },
    },
  },
  CONTACT: {
    name: 'contact',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  GAP_RESULTS: {
    name: 'gapresults/:statsType/:year/:scope/:courseId/:logicalErrorId',
    route(params: SchoolAdminParamsExtendedScopeAndCourse & LogicalErrorExtension): string[] {
      return [
        ...SCHOOL_ADMIN_ROUTE.route(),
        'gapresults',
        params.statsType,
        params.year,
        params.scope,
        params.courseId,
        params.logicalErrorId
      ];
    }
  },
  GET_STARTED: {
    name: 'getstarted',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  HELP_CENTER: {
    name: 'helpcenter',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  MATH_IMPROVEMENT: {
    name: 'mathimprovement',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  MATH_IMPROVEMENT_PRINT: {
    name: 'mathimprovementprint',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  PENDING_VERIFICATION: {
    name: 'pendingverification',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  PLC: {
    name: 'plc/:plcId',
    REPORTS: {
      name: 'results',
      route(plcId: string): string[] {
        return [...SCHOOL_ADMIN_ROUTE.PLC.route(plcId), this.name];
      }
    },

    route(plcId: string): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'plc', plcId];
    }
  },
  REMEDIATION: {
    name: 'remediation/:logicalErrorId',
    route(logicalErrorId: string): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), logicalErrorId];
    }
  },
  REMEDIATION_DOCUMENT: {
    name: 'remediation/:logicalErrorId/:documentType',
    queryParams(classId: string): Params {
      return { ClassId: encodeURI(classId) };
    },
    route(logicalErrorId: string, documentType: LogicalErrorDocumentType): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'remediation', logicalErrorId, documentType];
    }
  },
  SCHOOL_BOARD_INSIGHTS: {
    name: 'boardinsights/schoolboardinsights/:StatsType/:Year',
    route(statsType: string, year: string): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'boardinsights', 'schoolboardinsights', statsType, year];
    }
  },
  SCHOOL_BOARD_INSIGHTS_WITH_DETAIL:{
    name: 'boardinsights/schoolboardinsights/:StatsType/:Year/detail/:gradeLevel',
    queryParams(boardId: string, schoolId: string, scope: string, strandId: string = '', term: string = '', gradeLevel: string = ''): Params {
      return {
        [BoardOptionalParams.Board]: encodeURI(boardId),
        [BoardOptionalParams.School]: encodeURI(schoolId),
        [BoardOptionalParams.Scope]: encodeURI(scope),
        [BoardOptionalParams.Strand]: encodeURI(strandId),
        [BoardOptionalParams.Term]: encodeURI(term),
        [BoardOptionalParams.GradeLevel]: encodeURI(gradeLevel)
      };
    },
    route(statsType: string, year: string, gradeLevel: number): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'boardinsights', 'schoolboardinsights', statsType, year, 'detail', gradeLevel.toString()];
    }
  },
  SCHOOL_DASHBOARD: {
    name: 'schooldashboard/:Year',
    route(year: string):string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), 'schooldashboard', year];
    }
  },
  SETTINGS: {
    name: 'settings',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    }
  },
  VERIFY_ADMINISTRATORS: {
    name: 'verifyadministrators',
    route(): string[] {
      return [...SCHOOL_ADMIN_ROUTE.route(), this.name];
    },
    ACTION: {
      name: ':userId/action',
      route(userId: string): string[] {
        return [...SCHOOL_ADMIN_ROUTE.VERIFY_ADMINISTRATORS.route(), userId, 'action'];
      }
    }
  }
};
